import React, { useState, useEffect } from "react";
import { getViewLayout } from "../../editorPage/EditorBox/helpers/getViewLayout";
import styles from "./SlideViewer.module.css";
import LeftArrow from "../../../assets/leftArrow.svg";
import RightArrow from "../../../assets/rightArrow.svg";
import FullScreen from "../../../assets/fullscreen.svg";
import {
	openFullScreen,
	closeFullScreen,
} from "../../../helpers/handleFullScreen";

export default function SlideViewer(props) {
	const [currSlide, setCurrSlide] = useState(0);
	var xDown = null;
	var yDown = null;

	useEffect(() => {
		document.addEventListener("keyup", handleKeyup);
		document.addEventListener("touchstart", handleTouchStart, false);
		document.addEventListener("touchmove", handleTouchMove, false);
		return () => {
			document.removeEventListener("keyup", handleKeyup);
			document.removeEventListener("touchstart", handleTouchStart);
			document.removeEventListener("touchmove", handleTouchMove);
		};
	}, [currSlide]);

	const viewLayout = (currSlide) => {
		let slide = props.slides[currSlide];
		if (slide) {
			return getViewLayout(slide.id, slide.layout, slide.data);
		}
		return null;
	};

	const handlePrev = () => {
		let limit = props.slides.length - 1;
		if (currSlide > 0 && currSlide <= limit) {
			setCurrSlide(currSlide - 1);
		}
	};

	const handleNext = () => {
		let limit = props.slides.length - 1;
		if (currSlide >= 0 && currSlide < limit) {
			setCurrSlide(currSlide + 1);
		}
	};

	const handleKeyup = (e) => {
		e.preventDefault();
		if (
			e.keyCode === 39 ||
			e.key === "ArrowRight" ||
			e.code === "ArrowRight"
		) {
			handleNext();
		} else if (
			e.keyCode === 37 ||
			e.key === "ArrowLeft" ||
			e.code === "ArrowLeft"
		) {
			handlePrev();
		}
	};

	const toggleScreen = () => {
		let elem = document.getElementById("viewer_slider");
		if (document.fullscreenEnabled && !document.fullscreenElement) {
			openFullScreen(elem);
		} else {
			closeFullScreen(document);
		}
	};

	const getTouches = (evt) => {
		return (
			evt.touches || // browser API
			evt.originalEvent.touches
		); // jQuery
	};

	const handleTouchStart = (evt) => {
		const firstTouch = getTouches(evt)[0];
		xDown = firstTouch.clientX;
		yDown = firstTouch.clientY;
	};

	const handleTouchMove = (evt) => {
		if (!xDown || !yDown) {
			return;
		}

		var xUp = evt.touches[0].clientX;
		var yUp = evt.touches[0].clientY;

		var xDiff = xDown - xUp;
		var yDiff = yDown - yUp;

		if (Math.abs(xDiff) > Math.abs(yDiff)) {
			if (xDiff > 0) {
				/* left swipe */
				handleNext();
			} else {
				/* right swipe */
				handlePrev();
			}
		} else {
			evt.preventDefault();
			// if ( yDiff > 0 ) {
			// 	/* up swipe */
			// } else {
			// 	/* down swipe */
			// }
		}
		/* reset values */
		xDown = null;
		yDown = null;
	};

	return (
		<div id="viewer_slider" className={styles.slideViewer}>
			<div className={styles.layout}>
				{viewLayout(currSlide)}
				<img
					className={styles.controlPrev}
					src={LeftArrow}
					alt="Prev"
					onClick={handlePrev}
				/>

				<img
					className={styles.controlNext}
					src={RightArrow}
					alt="Next"
					onClick={handleNext}
				/>
			</div>
			<p className={styles.slideNumber}>{currSlide + 1}</p>
			<img
				className={styles.fullScreen}
				src={FullScreen}
				alt="Full Screen"
				onClick={toggleScreen}
			/>
			<div className={styles.mobileControls}>
				<p className={styles.controls} onClick={handlePrev}>
					Prev
				</p>
				<p className={styles.sn}>{currSlide + 1}</p>
				<p className={styles.controls} onClick={handleNext}>
					Next
				</p>
			</div>
		</div>
	);
}
